import ApplicationSerializer from 'lumen/serializers/application';

export default class CustomTagValueSerializer extends ApplicationSerializer {
  attrs = {
    definition: 'definition_id',
    listOption: 'list_option_id',
    subscription: 'subscription_id',
    user: 'user_id',
  };
}
